var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialist2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ededed;}.b{fill:#621ac0;}.c{fill:#cecece;}.d{fill:#fff;}.e{fill:#ff8f00;}.f{fill:#afafaf;}.g{fill:#e2e2e2;}.h{fill:#f8af23;}.i{fill:#3f3679;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-511 -339)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 102,
    height: 102,
    rx: 50,
    transform: "translate(511 339)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(524.557 354.569)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.976,31.439l8.179,6.142a2.31,2.31,0,0,0,1.66.447l7.838-.931a2.311,2.311,0,0,0-.545-4.589l-6.918.821-7.438-5.586a2.311,2.311,0,0,0-2.776,3.7Z",
    transform: "translate(-0.842 -0.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M40.725,30.464l1.389-1L49.67,39.991l-1.389,1Z",
    transform: "translate(-0.513 -0.397)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M13.92,29.456a5.708,5.708,0,1,0-5.708-5.708A5.708,5.708,0,0,0,13.92,29.456Z",
    transform: "translate(0 -0.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12.712,23.748A5.708,5.708,0,0,1,16.171,18.5a5.708,5.708,0,1,0,0,10.492A5.708,5.708,0,0,1,12.712,23.748Z",
    transform: "translate(0 -0.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M20.251,43.986H7.589V35.242a5.786,5.786,0,0,1,5.786-5.786h1.09a5.786,5.786,0,0,1,5.786,5.786v8.744Z",
    transform: "translate(0 -0.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.212,29.726a5.779,5.779,0,0,0-1.747-.27h-1.09a5.786,5.786,0,0,0-5.786,5.786v8.744h4.583V35.242A5.787,5.787,0,0,1,16.212,29.726Z",
    transform: "translate(0 -0.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M23.515,43.986a3.466,3.466,0,0,1,3.152,2.024l5.838,12.757a3.466,3.466,0,1,1-6.3,2.885L21.289,50.919H11.056a3.466,3.466,0,0,1-3.466-3.466V43.986H23.515Z",
    transform: "translate(0 -0.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M30.785,61.652,25.873,50.918H21.29L26.2,61.652a3.465,3.465,0,0,0,5.446,1.156A3.442,3.442,0,0,1,30.785,61.652Z",
    transform: "translate(-0.271 -0.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M12.173,47.452V43.986H7.589v3.466a3.466,3.466,0,0,0,3.466,3.466h4.583A3.466,3.466,0,0,1,12.173,47.452Z",
    transform: "translate(0 -0.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M29.857,41.349H19.628a2.311,2.311,0,0,1-1.6-.64l-5.708-5.45a2.311,2.311,0,1,1,3.192-3.343l5.038,4.811h9.3a2.311,2.311,0,0,1,0,4.622Z",
    transform: "translate(0 -0.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M62.08,29.456a5.708,5.708,0,1,0-5.708-5.708A5.708,5.708,0,0,0,62.08,29.456Z",
    transform: "translate(-0.842 -0.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M63.287,23.748A5.708,5.708,0,0,0,59.829,18.5a5.708,5.708,0,1,1,0,10.492A5.708,5.708,0,0,0,63.287,23.748Z",
    transform: "translate(-0.842 -0.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.749,43.986H68.411V35.242a5.786,5.786,0,0,0-5.786-5.786h-1.09a5.786,5.786,0,0,0-5.786,5.786v8.744Z",
    transform: "translate(-0.842 -0.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M59.788,29.726a5.779,5.779,0,0,1,1.747-.27h1.09a5.786,5.786,0,0,1,5.786,5.786v8.744H63.827V35.242A5.786,5.786,0,0,0,59.788,29.726Z",
    transform: "translate(-0.842 -0.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M52.485,43.986a3.466,3.466,0,0,0-3.152,2.024L43.495,58.767a3.466,3.466,0,1,0,6.3,2.885l4.912-10.733H64.944a3.466,3.466,0,0,0,3.466-3.466V43.986H52.485Z",
    transform: "translate(-0.842 -0.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45.215,61.652l4.912-10.733h4.583L49.8,61.652a3.465,3.465,0,0,1-5.446,1.156A3.446,3.446,0,0,0,45.215,61.652Z",
    transform: "translate(-0.571 -0.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M63.827,47.452V43.986h4.583v3.466a3.466,3.466,0,0,1-3.466,3.466H60.361A3.466,3.466,0,0,0,63.827,47.452Z",
    transform: "translate(-0.842 -0.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.144,41.349H56.372a2.311,2.311,0,0,0,1.6-.64l5.708-5.45a2.311,2.311,0,1,0-3.191-3.343l-5.039,4.811h-9.3a2.311,2.311,0,1,0,0,4.622Z",
    transform: "translate(-0.842 -0.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M47.261,31.074l-2.654,1.151-.084-2.891Z",
    transform: "translate(-0.513 -0.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44.505,29.318,50.53,19.83l2.738,1.739-6.025,9.488Z",
    transform: "translate(-0.559 -0.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.292,21.587l-2.738-1.74.92-1.447a1.622,1.622,0,0,1,2.738,1.741Z",
    transform: "translate(-0.593 -0.206)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M30.385,19.279a10.769,10.769,0,1,1,16.843-2.061l.431,4.1-4.105-.431A10.773,10.773,0,0,1,30.385,19.279Z",
    transform: "translate(-0.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M41.033,4.049a10.717,10.717,0,0,0-5.324-2.906A10.768,10.768,0,0,1,47.228,17.218l.431,4.1-4.1-.431c-.162.1-.328.19-.494.278l-.415-3.952A10.773,10.773,0,0,0,41.033,4.049Z",
    transform: "translate(-0.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M42.8,9.573A4.8,4.8,0,1,0,34.76,13.12v2.2a3.24,3.24,0,0,0,6.479,0v-2.2A4.791,4.791,0,0,0,42.8,9.573Z",
    transform: "translate(-0.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M34.76,15.319a3.24,3.24,0,1,0,6.479,0v-.429H34.76v.429Z",
    transform: "translate(-0.421 -0.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38,11.664a1.941,1.941,0,1,0-1.941-1.941A1.941,1.941,0,0,0,38,11.664Z",
    transform: "translate(-0.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38,22.91a11.206,11.206,0,0,0,5.66-1.535l3.951.415a.476.476,0,0,0,.38-.135.469.469,0,0,0,.135-.38l-.415-3.951A11.227,11.227,0,1,0,38,22.91ZM30.717,4.38a10.3,10.3,0,0,1,16.111,12.6.468.468,0,0,0-.065.291l.371,3.529L43.6,20.426a.481.481,0,0,0-.291.065,10.3,10.3,0,0,1-12.6-16.11Z",
    transform: "translate(-0.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M.907,63.431H74.251a.462.462,0,1,0,0-.923H71.426V29.269a.463.463,0,0,0-.927,0V49.944H66.735a3.86,3.86,0,0,0,1.376-2.952V34.967a6.167,6.167,0,0,0-4.15-5.81,6.108,6.108,0,1,0-5.147,0,6.2,6.2,0,0,0-3.243,2.615l-6-4.489,3.52-5.516L54,20.343a2.065,2.065,0,0,0-3.49-2.209L49.6,19.559,43.637,28.9a.457.457,0,0,0-.072.261h0l.06,2.027L42.045,29a.466.466,0,0,0-.647-.106l-1.374.983a.461.461,0,0,0-.106.644L44.157,36.4a2.733,2.733,0,0,0,1.473,5.045h9.034v1.674H51.9a3.9,3.9,0,0,0-3.538,2.263L42.59,57.943a3.869,3.869,0,0,0,1.024,4.565H31.543a3.869,3.869,0,0,0,1.024-4.565L26.795,45.38a3.9,3.9,0,0,0-3.538-2.263H20.493V41.443h9.034a2.738,2.738,0,1,0,0-5.475H20.515l-.022-.021v-.98a6.166,6.166,0,0,0-4.15-5.81,6.108,6.108,0,1,0-5.147,0,6.167,6.167,0,0,0-4.15,5.81V46.991a3.861,3.861,0,0,0,1.376,2.952H4.659V29.269a.463.463,0,0,0-.927,0V62.507H.907a.462.462,0,1,0,0,.924Zm19.585-.923V50.867h.265l4.733,10.3a3.862,3.862,0,0,0,1.022,1.34ZM54.4,50.867h.265V62.508H48.644a3.866,3.866,0,0,0,1.023-1.34Zm16.1,0V62.508H55.592V50.867H70.5ZM56.208,23.648a5.181,5.181,0,1,1,5.181,5.16A5.176,5.176,0,0,1,56.208,23.648ZM55.14,32.6a6.1,6.1,0,0,0-.475,2.363v.98l-.022.021H53.568c-.006,0-.01-.011-.017-.015l-6.444-4.819c.006-.008.014-.014.019-.023l1.944-3.046Zm-9.39-1.818-1.194.516-.038-1.3Zm4.384-10.343.962.609.963.609-5.466,8.564-1.925-1.219Zm1.158-1.814a1.146,1.146,0,0,1,1.575-.349,1.135,1.135,0,0,1,.351,1.568l-.661,1.036-.963-.609-.962-.609ZM46.19,31.6l5.838,4.366H47.071l-2.61-3.619Zm-5.248-1.244.621-.444,4.366,6.055h-.3a2.759,2.759,0,0,0-.594.066Zm2.867,8.348a1.82,1.82,0,0,1,1.822-1.814h9.2a.464.464,0,0,0,.32-.128l4.982-4.738a1.771,1.771,0,0,1,1.3-.5,1.814,1.814,0,0,1,1.216,3.126L57,40.017a1.816,1.816,0,0,1-1.258.5H45.631A1.819,1.819,0,0,1,43.809,38.705Zm11.783,2.738h.152a2.743,2.743,0,0,0,1.9-.758l5.644-5.367A2.738,2.738,0,0,0,61.452,30.6a2.777,2.777,0,0,0-1.961.757l-3.9,3.707v-.1a5.253,5.253,0,0,1,5.258-5.236h1.078a5.252,5.252,0,0,1,5.257,5.236v8.15H55.592Zm-10.7,20.8a2.95,2.95,0,0,1-1.462-3.912l5.773-12.563a2.972,2.972,0,0,1,2.7-1.724H67.185v2.952a2.962,2.962,0,0,1-2.964,2.952H54.1a.463.463,0,0,0-.421.27l-4.857,10.57A2.967,2.967,0,0,1,44.9,62.239ZM29.527,36.892a1.814,1.814,0,1,1,0,3.629H19.413a1.816,1.816,0,0,1-1.258-.5l-5.644-5.367a1.814,1.814,0,0,1,1.216-3.126h.043a1.81,1.81,0,0,1,1.257.5l4.982,4.738a.463.463,0,0,0,.32.128h9.2ZM8.589,23.648a5.181,5.181,0,1,1,5.181,5.16A5.176,5.176,0,0,1,8.589,23.648ZM7.973,34.967a5.252,5.252,0,0,1,5.257-5.236h1.078a5.253,5.253,0,0,1,5.258,5.236v.1l-3.9-3.707a2.743,2.743,0,1,0-3.8,3.959l5.644,5.367a2.743,2.743,0,0,0,1.9.758h.152v1.673H7.973Zm0,12.025V44.04H23.257a2.972,2.972,0,0,1,2.7,1.724l5.773,12.563a2.962,2.962,0,0,1-5.39,2.456l-4.857-10.57a.463.463,0,0,0-.421-.27H10.937A2.961,2.961,0,0,1,7.973,46.992ZM4.659,50.867H19.566V62.508H4.659Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.292,15.319a3.708,3.708,0,0,0,7.417,0v-2a5.273,5.273,0,1,0-7.417,0ZM38,18.09a2.773,2.773,0,0,1-2.769-2.732h5.538A2.773,2.773,0,0,1,38,18.09Zm0-6.9a1.472,1.472,0,1,1,1.472-1.472A1.474,1.474,0,0,1,38,11.195ZM33.664,9.573a4.336,4.336,0,1,1,7.259,3.2.468.468,0,0,0-.153.346v1.3h-2.3V12.086a2.409,2.409,0,1,0-.937,0v2.335h-2.3v-1.3a.469.469,0,0,0-.153-.346A4.346,4.346,0,0,1,33.664,9.573Z",
    transform: "translate(-0.421)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialist2);
export default __webpack_public_path__ + "static/media/specialist2.572c29ccf0ae585fdd884ec1a4752930.svg";
export { ForwardRef as ReactComponent };